import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  DashboardPage,
  ProfilePage,
  ChangePasswordPage,
  SessionCallPage,
  SessionCallPreviewPage,
  EulaPage,
  SessionsPage,
  NotFoundPage,
  ServerErrorPage
} from "pages";
import { isLogin } from "utils/auth";

export const ProtectedRoutes: React.FC = () => {
  if (!isLogin()) return <Redirect push to="/login" />;

  return (
    <Switch>
      <Route path="/dashboard" component={DashboardPage} />
      <Route path="/profile/password" component={ChangePasswordPage} />
      <Route path="/profile" component={ProfilePage} />
      <Route path="/eula" component={EulaPage} />
      <Route path="/sessions" component={SessionsPage} />
      <Route path="/session/:sessionId/join" component={SessionCallPage} />
      <Route
        path="/session/:sessionId/preview"
        component={SessionCallPreviewPage}
      />
      <Redirect exact from="/" to="/dashboard" />
      <Route path="/server-error" component={ServerErrorPage} />
      <Route component={() => <NotFoundPage />} />
    </Switch>
  );
};

export default ProtectedRoutes;
